// extracted by mini-css-extract-plugin
export default {"overlay":"AlertModal-module__overlay____rsQ4 Modal-module__overlay___Ej5Zs","content":"AlertModal-module__content___MvEll Modal-module__content___pj1hk"};